export default __webpack_public_path__ + "a6eedb308a10c79eea2001f60af9b7d0.svg";